import React, { useState } from 'react';
import { Alert, App, ConfigProvider } from 'antd';
import { useSearchParams } from 'react-router-dom';
import usePrompt from '../../../hooks/common/usePrompt';
import Tabs from '../../../components/Tabs';
// 결제 설정과 같은 '결제 관리' 메뉴라 화면 톤을 공유한다.
import { SettingsWorkspaceStyle } from '../../pgProviderRoute/common/styles';
import { FeePanel } from './FeePanel';
import { FeeHistoryPanel } from './FeeHistoryPanel/FeeHistoryPanel';

type PgProviderFeeWorkspaceProps = { canUpdate: boolean };
const TAB_KEYS = ['fees', 'history'] as const;

export const PgProviderFeeWorkspace = (props: PgProviderFeeWorkspaceProps): React.JSX.Element => {
  const { canUpdate } = props;
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') === 'history' ? 'history' : 'fees';
  const [isDirty, setDirty] = useState(false);
  usePrompt(isDirty, '저장하지 않은 수수료 변경이 있습니다. 이 페이지를 나가시겠습니까?');

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#7950f2',
          borderRadius: 4,
          colorText: '#283141',
          colorTextSecondary: '#626e7f',
          controlHeight: 36,
          controlHeightSM: 32,
        },
        components: { Button: { fontWeight: 500, paddingInline: 16, paddingInlineSM: 12 } },
      }}
    >
      <App>
        <SettingsWorkspaceStyle>
          <Alert
            className="settings-inline-alert"
            type="warning"
            showIcon
            message="이 값은 브랜드 정산금과 손익계산서에 직접 쓰입니다."
            description="정산용 컬럼을 바꾸면 다음 정산 생성분부터 반영됩니다. 이미 만들어진 정산은 금액이 확정 저장돼 있어 바뀌지 않습니다."
          />
          {!canUpdate && (
            <Alert
              className="settings-inline-alert"
              type="info"
              showIcon
              message="조회 권한으로 보고 있습니다. 수수료 변경에는 수정 권한이 필요합니다."
            />
          )}
          <Tabs
            activeKey={TAB_KEYS.indexOf(activeTab)}
            onChange={(key: number) =>
              setSearchParams(
                (previous) => {
                  const next = new URLSearchParams(previous);
                  next.set('tab', TAB_KEYS[key] ?? 'fees');
                  return next;
                },
                { replace: true },
              )
            }
            destroyInactiveTabPane={false}
            list={[
              {
                id: 0,
                title: (
                  <span className="settings-tab-label">
                    수수료 설정
                    {isDirty && <span className="settings-unsaved" role="img" aria-label="저장하지 않은 변경" />}
                  </span>
                ),
                forceRender: true,
                content: <FeePanel canUpdate={canUpdate} onDirtyChange={setDirty} />,
              },
              {
                id: 1,
                title: '변경 이력',
                content: activeTab === 'history' ? <FeeHistoryPanel /> : null,
              },
            ]}
          />
        </SettingsWorkspaceStyle>
      </App>
    </ConfigProvider>
  );
};
